module.exports = __webpack_public_path__ + "img/1-2.c5d4fa3.svg";